const BASE_URL = "https://api.glamourfashion.com.pk";
//const BASE_URL = "http://localhost:4002";

export default BASE_URL;